import { Outlet, Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'
import { LoadingSpinner } from '@/components/ui/loading-spinner'
import logoImage from '@/assets/logo.png'

export function AuthLayout() {
  const { isAuthenticated, isAdmin, isLoading } = useAuth()
  const location = useLocation()

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <LoadingSpinner size="lg" />
      </div>
    )
  }

  // The password-recovery link signs the user in (Supabase redeems the
  // token and establishes a session BEFORE redirecting here), so the
  // authenticated redirect below would skip the new-password form entirely.
  // /reset-password must stay reachable with a session — the page itself
  // requires one to call updateUser({ password }).
  const isPasswordReset = location.pathname === '/reset-password'

  // If authenticated, redirect to the appropriate home. Send everyone
  // through "/" (RootRedirect) so Otto-only routing lives in one place.
  if (isAuthenticated && !isPasswordReset) {
    return <Navigate to={isAdmin ? '/admin' : '/'} replace />
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted/50 px-4">
      <div className="w-full max-w-md">
        <div className="mb-8 flex flex-col items-center">
          <img src={logoImage} alt="Booked Rides" className="h-16 w-auto" />
        </div>
        <div className="rounded-lg border bg-card p-6 shadow-sm">
          <Outlet />
        </div>
      </div>
    </div>
  )
}
